// utils/precos/resolvePoliticaPreco.js

const toNumber = (value) => {
    const n = Number(value || 0);
    return Number.isFinite(n) ? n : 0;
};

// const limitarPercentual = (value, maximo = null) => {
//     const percentual = toNumber(value);

//     if (maximo === null || maximo === undefined || maximo === '') {
//         return percentual;
//     }

//     return Math.min(percentual, toNumber(maximo));
// };

export function resolverDescontoTabelaPreco({ tabelaPreco = {}, tabelaPrecoItem = {}, politicasDesconto = [], contexto = {} }) {
    const descontosPossiveis = [];

    if (tabelaPreco?.descontoGlobal) {
        descontosPossiveis.push({
            origem: 'TABELA_PRECO_GLOBAL',
            percentual: toNumber(tabelaPreco.descontoGlobal),
        });
    }

    if (tabelaPrecoItem?.descontoPercentualItemTabela) {
        descontosPossiveis.push({
            origem: 'TABELA_PRECO_ITEM',
            percentual: toNumber(tabelaPrecoItem.descontoPercentualItemTabela),
        });
    }

    for (const politica of politicasDesconto || []) {
        if (!politica?.ativo) continue;

        descontosPossiveis.push({
            origem: 'POLITICA_DESCONTO',
            politicaId: politica.id,
            descricao: politica.descricao,
            percentual: toNumber(politica.percentualDesconto),
        });
    }

    const melhorDesconto = descontosPossiveis.reduce((maior, atual) => (atual.percentual > maior.percentual ? atual : maior), {
        origem: null,
        percentual: 0,
    });

    return {
        descontoPermitidoPercentual: Number(melhorDesconto.percentual.toFixed(2)),
        origemDesconto: melhorDesconto.origem,
        politicaDescontoId: melhorDesconto.politicaId || null,
        descontosAvaliados: descontosPossiveis,
    };
}
